export default __webpack_public_path__ + "static/rectangle_tool.a1557e26e0ce47bd536ce7bd96c0e716.svg";